import React, {Component} from 'react';
import logo from "../../Image/gerb.svg"
import "./Header.css"
import {Row} from "react-bootstrap";



export default class Header extends Component {
    render() {
        return (
            <div className="hero">
               <Row>
               <img className="logo"
                     src={logo}

                     style={{


                         //width :'26px',
                         //height:'44px'
                     }}
                     alt="logo"
                /></Row>
                <div>
                    <div className="hero-text text-center col-auto">
                        Донецька обласна державна адміністрація
                    </div>
                </div>

                <div>

                </div>
            </div>
)
    }
}
